// extracted by css-extract-rspack-plugin
export default {"root":"root-rHVo5L","title":"title-N7E1Dy","form":"form-eMVqOq"};